import Crud from '../views/DispatchType/Crud'
import Entity from '../views/DispatchType/Add'

let routes = {
    path: '/dispatch_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/dispatch_types/add',
            name: 'NewDispatchType',
            component: Entity,
            meta: {
                pageTitle: 'dispatchType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchType.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_types/edit/:id?',
            name: 'EditDispatchType',
            component: Entity,
            meta: {
                pageTitle: 'dispatchType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchType.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/dispatch_types',
            name: 'list-dispatch-types',
            component: Crud,
            meta: {
                pageTitle: 'dispatchType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'dispatchType.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
